module.exports = __webpack_public_path__ + "static/yeni-amarok-03d047560b8325cc5bc151e6016d442a.jpg";